import React from "react";

const JourneyTimeline = () => {
  const timelineData = [
    {
      year: "2019",
      title: "Entered the Market as a Freelance Copywriter",
      description:
        "Started freelance web copywriting with little experience and recognition in the market.",
      side: "left",
    },
    {
      year: "2020",
      title: "Began University & Continued Freelancing",
      description:
        "Started university and discovered the depth of website development, continued copywriting as a freelance student.",
      side: "right",
    },
    {
      year: "2021",
      title: "Transitioned to Web Development",
      description:
        "Took a bold step into web development, creating mockups and practicing without a portfolio or reputation.",
      side: "left",
    },
    {
      year: "2022",
      title: "First Client Project Delivered",
      description:
        "Secured our first client via referral and delivered a complete website for an HR company in the UK.",
      side: "right",
    },
    {
      year: "2023",
      title: "Growth Through Local Projects",
      description:
        "Worked with local businesses and built small tools, steadily improving our skills and experience.",
      side: "left",
    },
    {
      year: "2024",
      title: "Breakthrough Project in Boston",
      description:
        "Reached beyond referrals, landed our first outbound client—a dental clinic in Boston—and helped increase their customer flow with our website.",
      side: "right",
    },
    {
      year: "2025",
      title: "Established as a Company in Missouri",
      description:
        "We are now a registered company in Missouri, helping local businesses stand out with recurring clients joining us on this new chapter.",
      side: "left",
    },
  ];

  return (
    <div
      style={{
        backgroundColor: "white",
        minHeight: "100vh",
        padding: "80px 20px",
        fontFamily: "system-ui, -apple-system, sans-serif",
      }}
    >
    

      {/* Timeline Container */}
      <div
        style={{
          maxWidth: "1000px",
          margin: "0 auto",
          position: "relative",
        }}
      >
        {/* Central Line */}
        <div
          style={{
            position: "absolute",
            left: "46.25%",
            top: "12px",
            bottom: "12px",
            width: "2px",
            backgroundColor: "#e0e0e0",
            transform: "translateX(-50%)",
            zIndex: 1,
          }}
        />

        {/* Timeline Items */}
        {timelineData.map((item, index) => (
          <div
            key={index}
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: index === timelineData.length - 1 ? "0" : "80px",
              position: "relative",
            }}
          >
            {/* Left Side Content */}
            <div
              style={{
                width: "45%",
                textAlign: item.side === "left" ? "right" : "left",
                paddingRight: item.side === "left" ? "50px" : "0",
                paddingLeft: item.side === "right" ? "50px" : "0",
                opacity: item.side === "left" ? 1 : 0,
                transition: "all 0.3s ease",
                cursor: item.side === "left" ? "pointer" : "default",
              }}
              onMouseEnter={(e) => {
                if (item.side === "left") {
                  e.currentTarget.style.transform = "scale(1.05)";
                  e.currentTarget.style.border = "2px solid #00643e";
                  e.currentTarget.style.borderRadius = "12px";
                  e.currentTarget.style.padding = "20px";
                  e.currentTarget.style.paddingRight = "50px";
                  e.currentTarget.style.boxShadow =
                    "0 4px 20px rgba(0, 100, 62, 0.15)";
                }
              }}
              onMouseLeave={(e) => {
                if (item.side === "left") {
                  e.currentTarget.style.transform = "scale(1)";
                  e.currentTarget.style.border = "none";
                  e.currentTarget.style.padding = "0";
                  e.currentTarget.style.paddingRight = "50px";
                  e.currentTarget.style.boxShadow = "none";
                }
              }}
            >
              {item.side === "left" && (
                <>
                  <div
                    style={{
                      fontSize: "1.1rem",
                      fontWeight: "600",
                      color: "#00643e",
                      marginBottom: "8px",
                    }}
                  >
                    {item.year}
                  </div>
                  <h3
                    style={{
                      fontSize: "1.3rem",
                      fontWeight: "600",
                      color: "#333",
                      margin: "0 0 12px 0",
                      lineHeight: "1.3",
                    }}
                  >
                    {item.title}
                  </h3>
                  <p
                    style={{
                      fontSize: "0.95rem",
                      color: "#666",
                      margin: 0,
                      lineHeight: "1.5",
                    }}
                  >
                    {item.description}
                  </p>
                </>
              )}
            </div>

            {/* Central Circle */}
            <div
              style={{
                width: "24px",
                height: "24px",
                backgroundColor: "#00643e",
                borderRadius: "50%",
                position: "relative",
                zIndex: 3,
                border: "4px solid white",
                boxShadow: "0 0 0 2px #00643e",
              }}
            />

            {/* Right Side Content */}
            <div
              style={{
                width: "45%",
                textAlign: item.side === "right" ? "left" : "right",
                paddingLeft: item.side === "right" ? "50px" : "0",
                paddingRight: item.side === "left" ? "50px" : "0",
                opacity: item.side === "right" ? 1 : 0,
                transition: "all 0.3s ease",
                cursor: item.side === "right" ? "pointer" : "default",
              }}
              onMouseEnter={(e) => {
                if (item.side === "right") {
                  e.currentTarget.style.transform = "scale(1.05)";
                  e.currentTarget.style.border = "2px solid #00643e";
                  e.currentTarget.style.borderRadius = "12px";
                  e.currentTarget.style.padding = "20px";
                  e.currentTarget.style.paddingLeft = "50px";
                  e.currentTarget.style.boxShadow =
                    "0 4px 20px rgba(0, 100, 62, 0.15)";
                }
              }}
              onMouseLeave={(e) => {
                if (item.side === "right") {
                  e.currentTarget.style.transform = "scale(1)";
                  e.currentTarget.style.border = "none";
                  e.currentTarget.style.padding = "0";
                  e.currentTarget.style.paddingLeft = "50px";
                  e.currentTarget.style.boxShadow = "none";
                }
              }}
            >
              {item.side === "right" && (
                <>
                  <div
                    style={{
                      fontSize: "1.1rem",
                      fontWeight: "600",
                      color: "#00643e",
                      marginBottom: "8px",
                    }}
                  >
                    {item.year}
                  </div>
                  <h3
                    style={{
                      fontSize: "1.3rem",
                      fontWeight: "600",
                      color: "#333",
                      margin: "0 0 12px 0",
                      lineHeight: "1.3",
                    }}
                  >
                    {item.title}
                  </h3>
                  <p
                    style={{
                      fontSize: "0.95rem",
                      color: "#666",
                      margin: 0,
                      lineHeight: "1.5",
                    }}
                  >
                    {item.description}
                  </p>
                </>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default JourneyTimeline;
